/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React base styles
import borders from "assets/theme-dark/base/borders";
import boxShadows from "assets/theme-dark/base/boxShadows";
import colors from "assets/theme-dark/base/colors";

const { borderRadius } = borders;
const { background, text } = colors;
const { xxl } = boxShadows;

const dialog = {
  styleOverrides: {
    // MUI mặc định lấy palette.background.paper (trắng) — nền tối phải đặt rõ, không thì chữ sáng trên nền trắng.
    paper: {
      backgroundColor: background.card,
      backgroundImage: "none",
      color: text.main,
      borderRadius: borderRadius.lg,
      boxShadow: xxl,
    },

    paperFullScreen: {
      borderRadius: 0,
    },
  },
};

export default dialog;
